/**
 * Shared placeholder used by screens whose port is queued for v2. Renders a
 * card explaining what the screen does and where in the source repo the
 * full implementation lives, so the next porting pass has clear breadcrumbs.
 */
import React from 'react';
import { Pressable, ScrollView, Text, View } from 'react-native';
import { IconWrench } from '../components/Icons';

export default function StubScreen({ title, sourcePath, summary, todo, ctaLabel, onCta }) {
  return (
    <ScrollView className="flex-1 bg-navy" contentContainerStyle={{ padding: 20, paddingBottom: 60 }}>
      <View className="bg-charcoal/40 border border-white/10 rounded-2xl p-6">
        <View className="mb-4"><IconWrench size={48} /></View>

        <Text className="text-2xl font-black text-white mb-2">{title}</Text>
        <Text className="text-white/60 leading-6 mb-5">{summary}</Text>

        <View className="bg-amber-500/10 border border-amber-500/20 rounded-xl p-4 mb-5">
          <Text className="text-[11px] font-bold text-amber-400 uppercase tracking-wider mb-1">Status: v2 Backlog</Text>
          <Text className="text-amber-200/80 text-sm">
            Ported scaffold pending. The web app continues to handle this flow — see the source path below for the
            full implementation.
          </Text>
        </View>

        <Text className="text-[11px] font-bold text-white/40 uppercase tracking-wider mb-2">Source on Web</Text>
        <View className="bg-black/30 border border-white/10 rounded-lg px-3 py-2.5 mb-5">
          <Text className="text-sky text-xs font-mono">{sourcePath}</Text>
        </View>

        {!!todo?.length && (
          <>
            <Text className="text-[11px] font-bold text-white/40 uppercase tracking-wider mb-2">To-Do for the Port</Text>
            <View className="gap-2 mb-5">
              {todo.map((t, i) => (
                <View key={i} className="flex-row items-start gap-2">
                  <Text className="text-sky">•</Text>
                  <Text className="text-sm text-white/60 flex-1">{t}</Text>
                </View>
              ))}
            </View>
          </>
        )}

        {ctaLabel && (
          <Pressable
            onPress={onCta}
            className="bg-sky py-3 rounded-xl items-center active:opacity-80"
          >
            <Text className="text-white font-bold">{ctaLabel}</Text>
          </Pressable>
        )}
      </View>
    </ScrollView>
  );
}
